import { IconPropsType } from '..';

export const RingIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.41254 13.3C8.28174 13.3 8.9868 12.5949 8.9868 11.725H5.83828C5.83828 12.5949 6.54334 13.3 7.41254 13.3ZM12.7132 9.61573C12.2377 9.10484 11.3481 8.33629 11.3481 5.81875C11.3481 3.9066 10.0074 2.3759 8.19955 2.00036V1.4875C8.19955 1.05265 7.84714 0.699997 7.41254 0.699997C6.97794 0.699997 6.62553 1.05265 6.62553 1.4875V2.00036C4.81773 2.3759 3.47701 3.9066 3.47701 5.81875C3.47701 8.33629 2.58738 9.10484 2.11193 9.61573C1.96427 9.77446 1.89881 9.9642 1.90004 10.15C1.90275 10.5536 2.21947 10.9375 2.69 10.9375H12.1351C12.6056 10.9375 12.9226 10.5536 12.925 10.15C12.9263 9.9642 12.8608 9.77421 12.7132 9.61573Z" />
  </svg>
);
